import { create } from "zustand";
import { SELECTION_METHOD } from "../utils/unifiedOffer";

export const useOffersSurgeSettingsStore = create((set) => ({
  open: false,
  offeringUuid: null,
  masterEnabled: true,
  selectionMethod: SELECTION_METHOD.LOWEST,
  setOpen: (open, offeringUuid = null) =>
    set((s) => ({
      open,
      offeringUuid: offeringUuid ?? s.offeringUuid,
    })),
  setMasterEnabled: (masterEnabled) => set({ masterEnabled }),
  setSelectionMethod: (selectionMethod) => set({ selectionMethod }),
  reset: () =>
    set({ open: false, masterEnabled: true, selectionMethod: SELECTION_METHOD.LOWEST }),
}));

